import * as React from "react";
import { useRouter } from "./useRouter.js";
import { useActiveLocation } from "./useActiveLocation.js";
function useNavigate(_defaultOpts) {
  const router = useRouter();
  const { getFromPath, activeLocation } = useActiveLocation();
  return React.useCallback(
    (options) => {
      const from = getFromPath(options.from ?? (_defaultOpts == null ? void 0 : _defaultOpts.from));
      return router.navigate({
        ...options,
        from
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [_defaultOpts == null ? void 0 : _defaultOpts.from, router, getFromPath, activeLocation]
  );
}
function Navigate(props) {
  const router = useRouter();
  const navigate = useNavigate();
  const previousPropsRef = React.useRef(null);
  React.useEffect(() => {
    if (previousPropsRef.current !== props) {
      navigate(props);
      previousPropsRef.current = props;
    }
  }, [router, props, navigate]);
  return null;
}
export {
  Navigate,
  useNavigate
};
//# sourceMappingURL=useNavigate.js.map
